// tslint:disable-next-line:no-any
const debounce = <A extends any[]>(func: (...args: A) => any, wait: number) => {
  let timeout: NodeJS.Timeout
  return (...args: A) => {
    const later = () => {
      // Execute the callback
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export default debounce
